import AttendanceIcon from '@/components/Icons/AttendanceIcon';
import PaySlipIcon from '@/components/Icons/PaySlipIcon';
import { ReactNode } from 'react';
import { RoutesLink } from '../utility/RouteLinks';
import HolidaysIcon from '@/components/Icons/HolidaysIcon';
import AttRegulerizationIcon from '@/components/Icons/AttRegulerizationIcon';
import LeaveIcon from '@/components/Icons/LeaveIcon';
import CompanyIcon from '@/components/Icons/CompanyIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { permissionKeys } from '@/utility/helper';
import HrmSetting from '@/components/Icons/HrmSettings';
import WorkFromHomeIcon from '@/components/Icons/WorkFromHomeIcon';
import ODAplicationIcon from '@/components/Icons/OdAplicationIcon';
export interface ISubMenuItem {
  label: string;
  permissionKey: string;
  to: string;
  relatedRoutes: string[];
  icon?: ReactNode;
  state?: {
    data?: {
      type?: string;
    };
  };
}
export interface IMenuItem extends ISubMenuItem {
  subMenu?: ISubMenuItem[];
  isShowBorder?: boolean;
}
export interface IGroupedMenu {
  Site: IMenuItem[];
  HRM: IMenuItem[];
}
const useSidebarLinks = () => {
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const groupedMenu: IGroupedMenu = {
    Site: [
      {
        label: 'Company',
        permissionKey: permissionKeys.company,
        to: RoutesLink.company,
        relatedRoutes: [
          RoutesLink?.addCompany,
          RoutesLink.companyDetail,
          RoutesLink.company,
          `${RoutesLink.editCompany}/:id`,
          `${RoutesLink.companyDetail}/:id`,
        ],
        icon: <CompanyIcon />,
      },
    ],

    HRM: [
      {
        label: 'Attendance',
        permissionKey: permissionKeys.attendance,
        to: '',
        relatedRoutes: [
          RoutesLink.teamAttendance,
          RoutesLink.attendance,
          RoutesLink?.attendanceLogs,
          RoutesLink.teamAttendance,
          RoutesLink.monthlyTeamAttendance,
          RoutesLink.monthlyTeamAttendanceDetail + '/:id',
        ],
        icon: <AttendanceIcon />,
        subMenu: [
          ...(userDetails?.type !== 1
            ? [
                {
                  label: 'My Attendance',
                  permissionKey: permissionKeys.attendance,
                  to: RoutesLink.attendance,
                  relatedRoutes: [
                    RoutesLink.attendance,
                    RoutesLink?.attendanceLogs,
                  ],
                },
              ]
            : []),
          ...(userDetails?.designation?.canAccessTeam || userDetails?.type === 1
            ? [
                {
                  label: 'Daily Team Att.',
                  permissionKey: permissionKeys.attendance,
                  to: RoutesLink.teamAttendance,
                  relatedRoutes: [RoutesLink.teamAttendance],
                },
                {
                  label: 'Monthly Team Att.',
                  permissionKey: permissionKeys.attendance,
                  to: RoutesLink.monthlyTeamAttendance,
                  relatedRoutes: [
                    RoutesLink.monthlyTeamAttendance,
                    RoutesLink.monthlyTeamAttendanceDetail + '/:id',
                  ],
                },
                {
                  label: 'Manage Bulk Att.',
                  permissionKey: permissionKeys.attendance,
                  to: RoutesLink.manageBulkAttendance,
                  relatedRoutes: [RoutesLink.manageBulkAttendance],
                },
              ]
            : []),
        ],
      },
      {
        label: 'Assets',
        permissionKey: permissionKeys.assets,
        to: RoutesLink?.assetsRequest,
        relatedRoutes: [],
        icon: <ODAplicationIcon />,
        subMenu: [],
      },
      {
        label: 'Extra Work',
        permissionKey: 'ew',
        to: '',
        relatedRoutes: [''],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: 'My Extra Work',
            permissionKey: 'ew',
            to: RoutesLink.underDevelopmentPage,
            relatedRoutes: [''],
          },

          {
            label: 'Team Extra Work',
            permissionKey: 'ew',
            to: RoutesLink.underDevelopmentPage,
            relatedRoutes: [''],
          },
        ],
      },
      {
        label: 'Leave',
        permissionKey: permissionKeys.leave,
        to: RoutesLink.myLeave,
        relatedRoutes: [
          RoutesLink.myLeave,
          RoutesLink.teamLeave,
          `${RoutesLink.leaveTeamDetail}/:id`,
          `${RoutesLink.leaveDetail}/:id`,
          RoutesLink.addLeave,
        ],
        icon: <LeaveIcon />,
        subMenu: [
          {
            label: 'My Leave',
            permissionKey: permissionKeys.leave,
            to: RoutesLink.myLeave,
            relatedRoutes: [
              RoutesLink.myLeave,
              RoutesLink.addLeave,
              `${RoutesLink.leaveDetail}/:id`,
            ],
          },
          ...(userDetails?.designation?.canAccessTeam || userDetails?.type === 1
            ? [
                {
                  label: 'Team Leave',
                  permissionKey: permissionKeys.leave,
                  to: RoutesLink.teamLeave,
                  relatedRoutes: [
                    RoutesLink.teamLeave,
                    `${RoutesLink.leaveTeamDetail}/:id`,
                  ],
                },
              ]
            : []),
        ],
      },
      {
        label: 'Regularization',
        permissionKey: permissionKeys.regularization,
        to: '',
        relatedRoutes: [
          RoutesLink.myRegularization,
          `${RoutesLink.arRequestDetail}/:id`,
          RoutesLink.teamAr,
          `${RoutesLink?.arTeamRequestDetail}/:id`,
        ],
        icon: <AttRegulerizationIcon />,
        subMenu: [
          {
            label: 'My Regularization',
            permissionKey: permissionKeys.regularization,
            to: RoutesLink.myRegularization,
            relatedRoutes: [
              RoutesLink?.myRegularization,
              `${RoutesLink.arRequestDetail}/:id`,
            ],
          },

          ...(userDetails?.designation?.canAccessTeam || userDetails?.type === 1
            ? [
                {
                  label: 'Team Regularization',
                  permissionKey: permissionKeys.regularization,
                  to: RoutesLink?.teamAr,
                  relatedRoutes: [
                    RoutesLink?.teamAr,
                    `${RoutesLink.arTeamRequestDetail}/:id`,
                  ],
                },
              ]
            : []),
        ],
      },
      {
        label: 'WFH',
        permissionKey: permissionKeys.wfh,
        to: '',
        relatedRoutes: [
          RoutesLink.teamWfh,
          RoutesLink.myWfh,
          RoutesLink.wfhRequestDetail + '/:id',
        ],
        // icon: <ODAplicationIcon />,
        icon: <WorkFromHomeIcon />,
        subMenu: [
          {
            label: 'My WFH',
            permissionKey: permissionKeys.wfh,
            to: RoutesLink.myWfh,
            relatedRoutes: [
              RoutesLink.myWfh,
              `${RoutesLink.wfhRequestDetail}/:id`,
            ],
          },

          ...(userDetails?.designation?.canAccessTeam || userDetails?.type === 1
            ? [
                {
                  label: 'Team WFH',
                  permissionKey: permissionKeys.wfh,
                  to: RoutesLink.teamWfh,
                  relatedRoutes: [
                    RoutesLink.teamWfh,
                    `${RoutesLink.wfhTeamRequestDetail}/:id`,
                  ],
                },
              ]
            : []),
        ],
      },
      {
        label: 'Payslip',
        permissionKey: permissionKeys.payslip,
        to: '',
        relatedRoutes: [RoutesLink.myPaySlip, RoutesLink.teamPayslips],
        icon: <PaySlipIcon />,
        subMenu: [
          {
            label: 'My Payslip',
            permissionKey: permissionKeys.payslip,
            to: RoutesLink.myPaySlip,
            relatedRoutes: [RoutesLink.myPaySlip],
          },

          ...(userDetails?.designation?.canAccessTeam || userDetails?.type === 1
            ? [
                {
                  label: 'Team Payslip',
                  permissionKey: permissionKeys.payslip,
                  to: RoutesLink.teamPayslips,
                  relatedRoutes: [RoutesLink.teamPayslips],
                },
              ]
            : []),
        ],
      },
      {
        label: 'Holidays',
        permissionKey: permissionKeys.holiday,
        to: RoutesLink.holidays,
        relatedRoutes: [RoutesLink.holidays],
        icon: <HolidaysIcon />,
      },
      {
        label: 'Employees',
        permissionKey: permissionKeys.show,
        to: RoutesLink.employees,
        relatedRoutes: [
          RoutesLink.employees,
          RoutesLink.detailEmployee + '/:id',
        ],
        icon: <AttendanceIcon />,
      },

      {
        label: 'HRM Settings',
        permissionKey: permissionKeys.hrmSetting,
        to: '',
        relatedRoutes: [
          RoutesLink.officeLocation,
          RoutesLink.addOffice,
          RoutesLink.shifts,
          RoutesLink.addShift,
          RoutesLink.department,
          RoutesLink?.leaveSetting,
          RoutesLink?.addLeaveSetting,
          RoutesLink?.addSalaryHead,
          RoutesLink?.salaryHead,
          RoutesLink.employeeDetail + '/:id',
          RoutesLink.editEmployeeOnBoard + '/:id',
          RoutesLink.addEmployeeOnBoard,
          RoutesLink.desgination,
          RoutesLink.addDesignation,
          RoutesLink.holiday,
          RoutesLink.policy,
          RoutesLink.salaryConfig,
          RoutesLink.siteSalaryHead,
          RoutesLink.addSiteSalaryHead,
          RoutesLink.assetsCategory,
          RoutesLink.assetRequests,
          RoutesLink.assetDetail + '/:id',
          RoutesLink.assets + '/:id',
          RoutesLink.addAsset,
        ],
        icon: <HrmSetting />,
        subMenu: [
          {
            label: 'Office Location',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.officeLocation,
            relatedRoutes: [RoutesLink.officeLocation, RoutesLink.addOffice],
          },
          {
            label: 'Biometric Devices',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.biometricDevices,
            relatedRoutes: [RoutesLink.biometricDevices],
          },
          {
            label: 'Shift & Time Config',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.shifts,
            relatedRoutes: [RoutesLink.shifts, RoutesLink.addShift],
          },
          {
            label: 'Department',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.department,
            relatedRoutes: [RoutesLink.department],
          },
          {
            label: 'Designation',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.desgination,
            relatedRoutes: [RoutesLink.desgination, RoutesLink.addDesignation],
          },
          {
            label: 'Employee Onboard',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.employeeOnBoard,
            relatedRoutes: [
              RoutesLink.employeeDetail + '/:id',
              RoutesLink.editEmployeeOnBoard + '/:id',
              RoutesLink.addEmployeeOnBoard,
            ],
          },
          {
            label: 'Holiday Setting',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.holiday,
            relatedRoutes: [RoutesLink.holiday],
          },
          {
            label: 'Leave Setting',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.leaveSetting,
            relatedRoutes: [
              RoutesLink?.leaveSetting,
              RoutesLink?.addLeaveSetting,
            ],
          },
          {
            label: 'Salary Head',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.salaryHead,
            relatedRoutes: [RoutesLink?.addSalaryHead, RoutesLink?.salaryHead],
          },

          {
            label: 'Office Salary Head',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.siteSalaryHead,
            relatedRoutes: [
              RoutesLink.siteSalaryHead,
              RoutesLink.addSiteSalaryHead,
            ],
          },
          {
            label: 'Salary Config',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.salaryConfig,
            relatedRoutes: [RoutesLink.salaryConfig],
          },
          {
            label: 'Documents',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink.policy,
            relatedRoutes: [RoutesLink.policy],
          },
          {
            label: 'Asset Category',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.assetsCategory,
            relatedRoutes: [
              RoutesLink.assetsCategory,
              `${RoutesLink.assetCategoryDetail}/:id`,
            ],
          },
          {
            label: 'Assets',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.assets,
            relatedRoutes: [
              RoutesLink.assets,
              `${RoutesLink?.assetDetail}/:id`,
              RoutesLink?.addAsset,
              `${RoutesLink?.addAsset}/:id`,
            ],
          },
          {
            label: 'Asset Requests',
            permissionKey: permissionKeys.hrmSetting,
            to: RoutesLink?.assetRequests,
            relatedRoutes: [RoutesLink.assetRequests],
          },
        ],
      },
    ],
    // Accounts: [
    //   {
    //     label: 'Work Order',
    //     permissionKey: 'wo',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Invoice',
    //     permissionKey: 'inv',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Debit Note',
    //     permissionKey: 'dn',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Day Book',
    //     permissionKey: 'cb',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Customer Ledger',
    //     permissionKey: 'cl',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Vendor Ledger',
    //     permissionKey: 'vl',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'TDS Ledger',
    //     permissionKey: 'tl',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },

    //   {
    //     label: 'Payment Advisory',
    //     permissionKey: 'pa',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: <LedgerIcon />,
    //   },
    //   {
    //     label: 'Payment Overview',
    //     permissionKey: 'pto',
    //     to: '',
    //     relatedRoutes: [''],
    //     icon: '',
    //     // icon: <VoucherIcon />,
    //   },
    // ],
  };

  return { groupedMenu };
};
export default useSidebarLinks;
